import { ReactNode } from "react"

export default function StickyFooter({ children }: { children: ReactNode }) {
  return (
    <div className="sticky bottom-0 z-10 mt-auto bg-gradient-to-t from-vm-cream via-vm-cream to-vm-cream/0 pb-6 pt-6">
      {children}
    </div>
  )
}
